import clsx from 'clsx';
import React, { useState } from 'react';
import { ExampleText } from './text/ExampleText';
import { UiGrid, UiText, UiFlex, UiButton } from '..';
import { UiExampleButton } from './button/UiExampleButton';
import { UiExampleInput } from './input/UiExampleInput';
import { UiExampleToolbar } from './toolbar/UiExampleToolbar';
var View;
(function (View) {
    View["UiText"] = "UiText";
    View["UiButton"] = "UiButton";
    View["UiInput"] = "UiInput";
    View["UiExampleToolbar"] = "UiExampleToolbar";
})(View || (View = {}));
export function UiExample() {
    var _a = useState(View.UiText), viewActive = _a[0], setViewActive = _a[1];
    return (React.createElement(UiGrid, { className: clsx('UiExample'), outerSpacing: 2 },
        React.createElement(UiText, { size: 3, weight: 2 }, "Component Examples"),
        React.createElement(UiFlex, { spacing: 1, overflowAuto: true }, Object.values(View).map(function (view) { return (React.createElement(UiButton, { onClick: function () { return setViewActive(view); }, color: viewActive === view ? 'primary' : 'default', variant: "filled", key: view }, view)); })),
        viewActive === View.UiText && React.createElement(ExampleText, null),
        viewActive === View.UiButton && React.createElement(UiExampleButton, null),
        viewActive === View.UiInput && React.createElement(UiExampleInput, null),
        viewActive === View.UiExampleToolbar && React.createElement(UiExampleToolbar, null)));
}
